module.exports = __webpack_public_path__ + "static/media/bscLogo-black.121e7d2c.ico";